export default __webpack_public_path__ + "static/media/erichettlin.88e5d48d.png";